function LinkHero() {
  return (
    <section class="hero is-info has-text-centered">
      <div className="hero-body">
        <p className="title">Human Characters</p>
        <p class="subtitle">
          <strong className="click">Click</strong> the Images for more
          information about that particular character
        </p>
      </div>
    </section>
  );
}

export default LinkHero;
